var render = function render(){var _vm=this,_c=_vm._self._c;return (this.params.value)?_c('div',{staticStyle:{"text-align":"right"}},[_c('div',[_vm._v(_vm._s(_vm.number)+" €")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }